module.exports = __webpack_public_path__ + "img/product_11.b5b0149b.svg";